import React from 'react'
import { Chip } from '@material-ui/core'
import { isLiteStatsMode } from '../../utils/constants/statsModeOptions'

const LITE_BADGE_STYLE = {
  backgroundColor: '#ADD8E6',
  color: '#000000',
  fontWeight: 600,
  fontSize: '0.7rem',
  height: 22,
  marginLeft: 8,
  maxWidth: 100,
}

const LiteModeBadge = ({ statsMode, style }) => {
  if (!isLiteStatsMode(statsMode)) return null

  return (
    <Chip
      label='lite'
      size='small'
      style={{ ...LITE_BADGE_STYLE, ...style }}
    />
  )
}

export default LiteModeBadge
